import { alpha, hexToRgb } from '@mui/system';

import { styled } from '../helpers';
import { Box, BoxProps } from 'Box';

const CalendarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSmall',
})<BoxProps & { isSmall?: boolean }>`
  & .MuiPickerStaticWrapper-root {
    min-width: unset;

    > div > div {
      width: 100%;
    }
  }

  & .MuiCalendarPicker-root {
    width: 100%;
    padding: 0;
    > div:first-of-type {
      display: flex;
      justify-content: space-between;
      margin-top: ${({ isSmall }) => (isSmall ? '16px' : '32px')};
      padding: ${({ isSmall }) => (isSmall ? '0 16px' : '0 32px')};

      & .MuiSvgIcon-root {
        color: ${({ theme }) => theme.palette.blueGrey['A400']};
      }

      [role='presentation'] {
        color: ${({ theme }) => theme.palette.blueGrey['900']};
        font-weight: 800;
        font-size: 0.875rem;
        line-height: 1rem;
        margin: 0;
        order: 2;
        padding-left: 8px;

        & .PrivatePickersFadeTransitionGroup-root:last-of-type {
          > div {
            margin: 0;
          }
        }

        & .MuiButtonBase-root {
          padding: 0;
          margin-left: 4px;
        }
      }

      > div:nth-of-type(2) {
        display: contents;
        > div {
          display: none;
        }

        > button:first-of-type {
          order: 1;
        }

        > button:last-of-type {
          order: 3;
        }
      }
    }
  }

  & .MuiCalendarPicker-viewTransitionContainer {
    margin-bottom: ${({ isSmall }) => (isSmall ? '16px' : '32px')};
    max-height: ${({ isSmall }) => (isSmall ? '223px' : '251px')};

    > div > div:first-of-type:not(.MuiYearPicker-root):not(.MuiMonthPicker-root) {
      margin-bottom: 5px;
      padding: ${({ isSmall }) => (isSmall ? '0 16px' : '0 32px')};

      & .MuiTypography-caption {
        border-bottom: 2px solid ${({ theme }) => theme.palette.grey['A100']};
        color: ${({ theme }) => theme.palette.blueGrey['A400']};
        flex: 1;
        font-weight: 800;
        line-height: 1rem;
        margin: 0;
      }
    }

    & .MuiYearPicker-root {
      justify-content: center;

      .PrivatePickersYear-root {
        &.PrivatePickersYear-modeMobile {
          flex-basis: unset;
          height: 32px;
          width: 66px;
          margin: ${({ isSmall }) => (isSmall ? '6x' : '12px')};

          & .PrivatePickersYear-yearButton {
            color: ${({ theme }) => theme.palette.blueGrey['900']};
            font-size: 0.875rem;
            line-height: 1.25rem;
            height: 32px;
            width: 66px;
            margin: 0;

            &.Mui-selected {
              color: ${({ theme }) => theme.palette.primary.contrastText};
            }
          }
        }
      }
    }

    & .PrivatePickersSlideTransition-root {
      min-height: ${({ isSmall }) => (isSmall ? '174px' : '206px')};
      margin: ${({ isSmall }) => (isSmall ? '0 16px' : '0 32px')};

      [role='cell'] {
        flex: 1;
        text-align: center;
      }

      & .MuiPickersDay-root {
        &.MuiPickersDay-dayWithMargin {
          color: ${({ theme }) => theme.palette.blueGrey['900']};
          font-size: 0.75rem;
          font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
          line-height: 1rem;
          width: ${({ isSmall }) => (isSmall ? '24px' : '32px')};
          height: ${({ isSmall }) => (isSmall ? '24px' : '32px')};
          margin: 0;

          &:hover {
            background-color: ${({ theme }) => alpha(hexToRgb(theme.palette.blue['800']), 0.25)};
          }

          &.MuiButtonBase-root.Mui-selected {
            color: ${({ theme }) => theme.palette.primary.contrastText};
            background-color: ${({ theme }) => theme.palette.blue['800']};

            &.pseudo-focus {
              background-color: ${({ theme }) => theme.palette.blue['800']};
            }
          }

          &.MuiPickersDay-dayOutsideMonth {
            color: ${({ theme }) => theme.palette.blueGrey['A400']};
          }
        }
      }
    }
  }
`;

export { CalendarContainer };
